import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { data } from "jquery";
import { Pagination } from "../../Components/Pagination";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

export default function AccordionTable({
  apiData,
  DisplayFields,
  isArrayData,
  setApiData,
  _index,
  setAccordionTable,
  widthRefAccordionTable,
}) {
  const { lang, proxy, database } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const [dataParams, setDataParams] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const getParams = useRef({});
  const [currentPage, setCurrentPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);
  const [dataFilter, setDataFilter] = useState(dataParams);
  const [selectedItems, setSelectedItems] = useState([]);

  const dataPerPage = 15;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData =
    dataFilter && dataFilter.slice(indexOfFirstData, indexOfLastData);
  const totalPages = dataFilter && dataFilter.length;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleCheckboxChange = (e, item, index) => {
    const updatedSelectedItems = e.target.checked
      ? [...(selectedItems[index] || []), item].filter(Boolean)
      : (selectedItems[index] || []).filter((i) => i !== item).filter(Boolean);

    const updatedSelectedItemsCopy = [...selectedItems];
    updatedSelectedItemsCopy[index] = updatedSelectedItems;

    setSelectedItems(updatedSelectedItemsCopy);

    if (updatedSelectedItems.length > 0) {
      const newData = dataParams.filter((data) =>
        updatedSelectedItems.some((selected) =>
          Object.keys(data).some((key) => {
            return data[key] && data[key] === selected;
          })
        )
      );
      setDataFilter(newData);
    } else {
      setDataFilter(dataParams);
    }
  };

  useEffect(() => {
    if (getParams.current) {
      const { api_fields, items } = getParams.current;
      fetchForeignData(api_fields, items);
    }
  }, [getParams]);

  async function fetchForeignData(payload, params) {
    // setLoading(false);
    if (payload) {
      const api = payload.find((item) => item.api_method == "get");
      if (api) {
        const { url } = api;
        try {
          const promises = params.map((param) => {
            return fetch(`${proxy()}${url}/${param}`, {
              method: "GET",
              headers: {
                "content-type": "application/json",
                Authorization: _token,
              },
            })
              .then((res) => res.json())
              .then((res) => res.data);
          });

          const results = await Promise.all(promises);

          if (results.length) {
            setDataParams(results.flat());
            setDataFilter(results.flat());
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
    }
    setLoading(false);
  }

  const handleUpdateFieldsByCondition = (
    condition_fields,
    apis,
    update_fields,
    param,
    index,
    modal_title
  ) => {
    const api = apis.find((item) => item.api_method == "put");
    const { api_method, url } = api;
    const payload = {};
    const params = condition_fields
      .map((item) => {
        if (Array.isArray(apiData[item.fomular_alias])) {
          return apiData[item.fomular_alias][index];
        } else {
          return apiData[item.fomular_alias];
        }
      })
      .flat();

    update_fields?.map((item) => {
      if (apiData && apiData[item?.fomular_alias]) {
        payload[item.fomular_alias] = Array.isArray(apiData[item.fomular_alias])
          ? param
          : apiData[item.fomular_alias];
      } else {
        payload[item.fomular_alias] = isNaN(item.default_value)
          ? item.default_value
          : parseInt(item.default_value) || item.default_value === "0"
          ? parseInt(item.default_value)
          : "";
      }
    });
    Swal.fire({
      title: lang["confirm"],
      text: modal_title,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: lang["confirm"],
      cancelButtonText: lang["btn.cancel"],
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${proxy()}${url}/${params.join("/")}`, {
          method: api_method.toLowerCase(),
          headers: {
            Authorization: _token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json())
          .then((resp) => {
            const { success, data, errors, message } = resp;
            let text = "";
            for (const m in message) {
              text = message[m];
            }
            if (message && Object.values(message).length) {
              Swal.fire({
                title: lang["error"],
                icon: "error",
                text: lang[text] || text,
                showConfirmButton: true,
                // timer: 1500,
              });
              return;
            }

            if (success) {
              Swal.fire({
                title: lang["success"],
                // text: `OK`,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                setApiData((prev) => prev.filter((_, idx) => idx !== _index));
                setAccordionTable(false);
              });
            }
            if (errors) {
              const { messages } = errors;
              let message = "";
              let name = "";
              database?.fields.map((item) => {
                if (messages?.[item?.fomular_alias]) {
                  name = item?.field_name;
                  message = messages?.[item?.fomular_alias];
                }
              });
              Swal.fire({
                title: lang["error"],
                text: `${name} ${lang[message]}`,
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
      }
    });
  };

  return DisplayFields && DisplayFields.length > 0 ? (
    DisplayFields.map((field, index) => {
      const {
        condition_fields,
        update_fields,
        modal_title,
        api_fields,
        button_icon,
        button_color,
        button_background,
        is_show,
      } = field;

      const mapped_fields =
        update_fields &&
        update_fields.length > 0 &&
        update_fields
          .map((item) => {
            const newData = [];
            const field = database.fields.find(
              (field) => field.fomular_alias === item.fomular_alias
            );
            if (field) {
              return {
                field_name: field.field_name,
                ...item,
              };
            }
            database.fields.map((field) => {
              if (item.is_show && item.is_show.length > 0) {
                const findShow = item.is_show.find(
                  (show) => show.value === field.fomular_alias
                );
                if (findShow) {
                  newData.push(findShow);
                }
              }
            });
            // if (newData.length > 0) {
            //   const hasMatch = newData.some(
            //     (data) => data.value === item.fomular_alias
            //   );
            //   return hasMatch
            //     ? {
            //         field_name: item.default_name,
            //         ...item,
            //       }
            //     : null;
            // }
            // return null;
          })
          .filter(Boolean);
      const items =
        condition_fields &&
        (() => {
          const arrays = condition_fields
            .map((item) => apiData?.[item?.fomular_alias])
            .filter((data) => (Array.isArray(data) ? data : [data]));

          const suffixes = condition_fields
            .map((item) => apiData?.[item?.fomular_alias])
            .filter((data) => typeof data === "string");

          // if (arrays.length === 0 || suffixes.length === 0) return [];

          return arrays.flat();
          //.map((value) => `${value}/${suffixes.join("/")}`);
        })();

      if (items && items.length > 0) {
        getParams.current = { api_fields, items };
        // fetchForeignData(api_fields, items);
      }
      let optionFilter = [];

      update_fields &&
        update_fields.length &&
        dataParams
          .map((item) => {
            update_fields.forEach((field) => {
              const { is_filter } = field;
              if (is_filter && is_filter.length > 0) {
                is_filter.forEach((show) => {
                  const value = item?.[show?.value];
                  if (value && !optionFilter.includes(value)) {
                    optionFilter.push(value);
                  }
                });
              }
            });
            return item;
          })
          .filter(Boolean)
          .map(() => [...new Set(optionFilter)]);

      return condition_fields &&
        condition_fields.length > 0 &&
        update_fields &&
        update_fields.length > 0 ? (
        <>
          <td
            colSpan={DisplayFields.length + 2}
            className="pl-4 pr-4 pt-2 pb-2"
            style={{
              background: "#e9ecef",
            }}
          >
            <div
              className="fold-content"
              style={{
                width: (widthRefAccordionTable || 0) - 40 + "px",
                overflowX: "auto",
              }}
            >
              <Table className="table m-0 p-2">
                <thead>
                  <tr>
                    {dataParams && dataParams.length > 0 && (
                      <td>
                        #
                        {optionFilter && optionFilter.length ? (
                          <>
                            <FontAwesomeIcon
                              icon={faFilter}
                              color="#34a83e"
                              fontSize={14}
                              onClick={() => setOpenFilter((prev) => !prev)}
                            />
                            {openFilter && (
                              <div
                                className="position-absolute"
                                style={{
                                  zIndex: 999,
                                  width: "fit-content",
                                }}
                              >
                                <div className="card">
                                  <div className="card-header">Lọc giá trị</div>
                                  <div className="card-body">
                                    {optionFilter && optionFilter.length > 0
                                      ? optionFilter.map((item, index) => (
                                          <p className="p-2">
                                            <input
                                              id={`checkbox-${item}`}
                                              className="form-check-input"
                                              type="checkbox"
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  item,
                                                  _index
                                                )
                                              }
                                              checked={selectedItems[
                                                _index
                                              ]?.includes(item)}
                                            />
                                            <label htmlFor={`checkbox-${item}`}>
                                              {item}
                                            </label>
                                          </p>
                                        ))
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : null}
                      </td>
                    )}
                    {update_fields.map((field, fieldIndex) => {
                      const { field_name, is_show, default_name, textAlign } =
                        field;
                      return (
                        is_show &&
                        is_show.length > 0 && (
                          <td
                            className="p-1"
                            key={fieldIndex}
                            style={{
                              width: "unset !important",
                            }}
                          >
                            {field_name || default_name}
                          </td>
                        )
                      );
                    })}
                    {button_icon?.icon && <td>Thao tác</td>}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr style={{ textAlign: "center" }}>
                      <td colSpan={DisplayFields.length + 2}>
                        <img
                          width={35}
                          className="mb-1"
                          src="/images/icon/load.gif"
                          alt="Loading..."
                        ></img>
                      </td>
                    </tr>
                  ) : currentData && currentData.length > 0 ? (
                    currentData.map((itemData, index) => (
                      <tr key={index}>
                        {/* {update_fields.length &&
                        update_fields.filter(({ is_filter }) => is_filter) ? (
                          <td></td>
                        ) : null} */}
                        <td>{indexOfFirstData + index + 1}</td>
                        {update_fields.map((field, tdIndex) => {
                          const { is_show, textAlign, is_filter, is_merge } =
                            field;

                          if (!is_show || is_show.length === 0) return null;

                          const groupRows = currentData.filter(
                            (d) => d.groupId === itemData.groupId
                          );
                          const rowSpan = groupRows.length;

                          const groupIndex = groupRows.findIndex(
                            (d) =>
                              d.maPhieuNhapKhoERP === itemData.maPhieuNhapKhoERP
                          );

                          if (is_merge && groupIndex > 0) return null;

                          return (
                            <td
                              key={tdIndex}
                              className="cell"
                              style={{
                                whiteSpace: "pre",
                                width: "min-content !important",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                textAlign: textAlign,
                              }}
                              rowSpan={is_merge ? rowSpan : 1}
                              title={is_show
                                .map(
                                  (item) =>
                                    itemData?.[item?.value]?.value ||
                                    itemData?.[item?.value]
                                )
                                .join("\n")}
                            >
                              {is_show.map((item, index) => (
                                <div
                                  key={index}
                                  style={itemData?.[item?.value]?.styles}
                                >
                                  {itemData?.[item?.value]?.value ||
                                    itemData?.[item?.value]}
                                </div>
                              ))}
                            </td>
                          );
                        })}

                        {button_icon?.icon && (
                          <td className="align-center actions">
                            <div className="icon-table">
                              <div
                                className="icon-table-line"
                                style={{
                                  color: button_color && button_color,
                                  background:
                                    button_background && button_background,
                                  height: "42px",
                                  width: "42px",
                                  fontSize: "20px",
                                }}
                                onClick={() =>
                                  handleUpdateFieldsByCondition(
                                    condition_fields,
                                    api_fields,
                                    update_fields,
                                    items?.[0],
                                    index,
                                    modal_title
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={button_icon?.icon} />
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        className="align-center"
                        colSpan={update_fields.length + 5}
                      >
                        {lang["not found data"]}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {dataParams && dataParams.length > 15 && (
                <div className="mt-2">
                  <Pagination
                    total={totalPages}
                    itemsPerPage={dataPerPage}
                    currentPage={currentPage}
                    paginate={paginate}
                    lang={lang}
                  />
                </div>
              )}
            </div>
          </td>
        </>
      ) : null;
    })
  ) : (
    <>
      <td className="align-center" colSpan={DisplayFields.length + 2}>
        {lang["not found data"]}
      </td>
    </>
  );
}
